import React, { FC } from 'react';
import { ComponentKeys } from '@components/EntityDrawers/drawers/Component/keys';
import ControlledLinkInput from '@components/Inputs/controllers/ControlledLinkInput';
import { useProject } from '@context/Project/ProjectProvider';

const ImplementationGuidance: FC = () => {
  const { viewOnly } = useProject();

  return (
    <ControlledLinkInput
      name={ComponentKeys.ImplementationGuidance}
      label="Implementation Guidance"
      placeholder="Implementation Guidance"
      disabled={viewOnly}
      multiline
    />
  );
};

export default ImplementationGuidance;
